import { render } from "./SocialNetworks.vue?vue&type=template&id=73b2c506&scoped=true&ts=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=ts"
export * from "./SocialNetworks.vue?vue&type=script&lang=ts"

import "./SocialNetworks.vue?vue&type=style&index=0&id=73b2c506&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/atomic-design/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73b2c506"]])

export default __exports__